<template>
<div>
    <b-input-group class="filter-group">
      <b-input-group-prepend is-text>
          <font-awesome-icon icon="search" />
      </b-input-group-prepend>
      <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
      <b-input-group-append>
          <b-button @click="filter = null">Clear</b-button>
      </b-input-group-append>
    </b-input-group>

    <b-table striped
          hover
          :items="students"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-compare="customSort"
          :filter="filter"
          @filtered="onFiltered"
          responsive>
          <template slot="GPA" slot-scope="data">
            {{ data.item.cumulativeGpa }}
          </template>
          <template slot="creditHours" slot-scope="data">
            {{ data.item.totalCumulative }}
          </template>
          <template slot="intent" slot-scope="data">
            {{ hasIntent(data.item.asuriteId) | trueOrFalse}}
          </template>
          <template slot="details" slot-scope="data">
            <router-link :to="{ name: 'studentDetails', params: { id: data.item.asuriteId } }">View</router-link> 
          </template>
    </b-table>
</div>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      fields: [
        { key: "firstName", sortable: true },
        { key: "lastName", sortable: true },
        { key: "asuriteId", sortable: true },
        { key: "majorCode", sortable: true },
        { key: "GPA", sortable: true },
        { key: "creditHours", sortable: true },
        { key: "opportunityCount", label: "Opportunities", sortable: true },
        { key: "intent", sortable: true },
        { key: "details", sortable: false }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      filter: null
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  props: {
    students: {
      type: Array,
      required: true
    }
  },

  methods: {
    customSort(a, b, key) {
      var categoryNameA;
      var categoryNameB;
      if (key === "name") {
        categoryNameA = a.opportunity.name;
        categoryNameB = b.opportunity.name;
        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "term") {
        categoryNameA = a.opportunity.term.description;
        categoryNameB = b.opportunity.term.description;
        return categoryNameA.localeCompare(categoryNameB);
      } else {
        return null;
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    hasIntent: function(asurite) {
      var student = _.find(this.students, function(student) {
        return student.asuriteId === asurite;
      });
      return _.find(student.studentOpportunities, function(opportunity) {
        return opportunity.primarySelection === true;
      });
    }
  }
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.new-content-button {
  margin-left: 10px;
}
</style>
